import { apiRequest, apiFormRequest } from './api';

export async function getUsers() {
  const response = await apiRequest('/auth/users');
  return response;
}

export async function deleteUser(id) {
  const response = await apiRequest(`/auth/users/${id}`, {
    method: 'DELETE',
  });
  return response;
}

export async function createUser(data) {
  if (data instanceof FormData) {
    const response = await apiFormRequest('/auth/users', data);
    return response.user;
  }

  const response = await apiRequest('/auth/users', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return response.user;
}
